import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { getDataSession, validarExisteSucursalPrincipal } from 'views/Utils/Common';
import { useGlobalState } from 'resources/GlobalStateContext';
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import { fetchConToken } from 'helpers/fetch';
import Swal from 'sweetalert2';
import { useRecepcionCompra } from './RecepcionCompra';

const List = ({ match }) => {
    const { path } = match;
    const { setGlobalTitulo } = useGlobalState();
    const { compras } = match.params;
    const [actualizarTabla, setActualizarTabla] = useState(false);

    let TipoDocto = 'C';
    let Docto = 'C';

    switch (compras) {
        case 'ordenesCompras':
            TipoDocto = 'O';
            Docto = 'Ordenes compras';
            break;
        case 'recepcionCompra':
            TipoDocto = 'R';
            Docto = 'Recepciones de compras';
            break;
        default:
            TipoDocto = 'C';
            Docto = 'Compras';
            break;
    }

    function getactualizarTabla() {
        setActualizarTabla(true);
        setActualizarTabla(false);
    }

    const { abrirRecepcion, RecepcionCompraPortal } = useRecepcionCompra({
        onSuccess: getactualizarTabla
    });

    const convertirCompra = (orden_id) => {
        Swal.fire({
            text: '¿Desea convertir esta orden a compra? ',
            showCancelButton: true,
            confirmButtonText: 'Si, convertir',
            cancelButtonText: 'No'
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(`VxCompras/GenerarCompra?orden_id=${orden_id}`, {}, 'POST')
                .then((response) => {
                    if (response.hasOwnProperty('status')) {
                        Object.entries(response.errors).forEach(([, value]) => {
                            Swal.fire('Error', value[0], 'error');
                        });
                        return;
                    }
                    if (response.hasOwnProperty('codigo')) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return;
                    }
                    Swal.fire('Exito', 'Se convirtio a compra correctamente', 'success');
                    getactualizarTabla();
                })
                .catch((error) => console.error('Error al convertir a compra:', error));
        });
    };

    const cancelarCompra = (documento_id) => {
        Swal.fire({
            text: '¿Desea cancelar el documento?',
            showCancelButton: true,
            confirmButtonText: 'Si, cancelar',
            cancelButtonText: 'No'
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(`VxCompras/Cancelar?documento_id=${documento_id}`, {}, 'POST')
                .then((response) => {
                    if (response?.hasOwnProperty('status') && response.status === 400) {
                        Object.entries(response.errors).forEach(([, value]) => {
                            Swal.fire('Error', value[0], 'error');
                        });
                        return;
                    }
                    if (response?.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return;
                    }
                    Swal.fire('Exito', 'Cancelado Correctamente', 'success');
                    getactualizarTabla();
                })
                .catch((error) => console.error('Error al cancelar:', error));
        });
    };

    const opciones = useMemo(() => {
        let ops = 'editar,cancelarCompra';
        if (TipoDocto === 'O') ops += ',convertirCompra';
        if (TipoDocto === 'C') ops += ',recepcionCompra';
        return ops;
    }, [TipoDocto]);

    const columns = useMemo(() => [
        {
            renderCell: RenderButtons,
            headerName: '',
            maxWidth: 20,
            path: path.replace(':compras', compras),
            opciones,
            width: 5,
            convertirCompra,
            recepcionCompra: abrirRecepcion,
            cancelarCompra
        },
        { field: 'id', headerName: 'Id', width: 70 },
        { field: 'folio', headerName: 'Folio', flex: 1 },
        { field: 'fecha', headerName: 'Fecha', flex: 1, renderCell: ({ value }) => value?.substring(0, 10) },
        { field: 'proveedor_Nombre', headerName: 'Proveedor', flex: 1 },
        { field: 'folio_Prov', headerName: 'Folio Prov.', flex: 1 },
        { field: 'estatus_Documento', headerName: '', flex: 1 }
    ], [path, compras, opciones, abrirRecepcion]);

    React.useEffect(() => {
        setGlobalTitulo(prev => ({
            ...prev,
            titulo: Docto,
            subtitulo: `Listado de ${Docto} por sucursal.`
        }));
        validarExisteSucursalPrincipal();
    }, [Docto, setGlobalTitulo]);

    return (
        <>
            <div className='container-fluid'>
                <div className='col-md-12'>
                    <div className='col-md-12'>
                        <Link to={`${compras}/add`} className='btn btn-outline-primary'>
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='20'
                                height='20'
                                fill='currentColor'
                                className='bi bi-plus-square'
                                viewBox='0 0 16 16'
                            >
                                <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                                <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                            </svg>
                            &nbsp; Nuevo
                        </Link>
                        &nbsp; &nbsp;
                    </div>
                </div>

                <div style={{ height: 400, width: '100%' }}>
                    <ListTable
                        columns={columns}
                        path={path}
                        url={`VxCompras/GetList?sucursal_Id=${getDataSession('sucursal')}&tipo_docto=${TipoDocto}`}
                        reload={actualizarTabla}
                    />
                </div>
            </div>
            <RecepcionCompraPortal />
        </>
    );
};

export { List };
